import React from 'react';
import {statusFilterConfig, statusList, styles} from './config.ts';
import {StatusFilterValue} from '../../types.ts';

type StatusFilterProps = {
  onChange: (value: StatusFilterValue) => void;
  selectedValues?: StatusFilterValue[];
  t: (key: string) => string;
};

type StatusChipButtonProps = {
  text: string;
  isActive?: boolean;
  onClick?: () => void;
};

const StatusChipButton = ({
  text,
  isActive = false,
  onClick
}: StatusChipButtonProps) => {
  const variant = isActive ? 'active' : 'default';
  return (
    <div
      className="flex h-[44px] w-min cursor-pointer items-center justify-center rounded-[44px] px-[18px] whitespace-nowrap"
      onClick={onClick}
      style={{...styles[variant].container}}
    >
      <span className="text-sm" style={{...styles[variant].text}}>
        {text}
      </span>
    </div>
  );
};

const StatusFilter = ({
  t,
  onChange,
  selectedValues = []
}: StatusFilterProps) => {
  return (
    <div className="flex flex-row flex-wrap gap-[12px]">
      {statusList.map(status => (
        <StatusChipButton
          key={status}
          text={t(statusFilterConfig[status].text)}
          isActive={selectedValues?.includes(status)}
          onClick={() => onChange(status)}
        />
      ))}
    </div>
  );
};

export default StatusFilter;
